'use es6';

import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ImagePage = ({
  image,
  content,
  children
}) => /*#__PURE__*/_jsxs("div", {
  className: "image-page",
  children: [/*#__PURE__*/_jsxs("div", {
    className: "text-center",
    children: [image, /*#__PURE__*/_jsx("div", {
      className: "display-inline-block text text-center v-a-middle",
      children: children
    })]
  }), content]
});
ImagePage.propTypes = {
  children: PropTypes.node,
  content: PropTypes.node,
  image: PropTypes.node
};
export default ImagePage;